import React from "react";
import { FleetTaskCreateButton } from "./fleet-task-create-button.js";
import { FleetStatePredictor } from "../util/fleet-state-predictor.js";
import { Task } from "./fleet-task.js";
import * as util from "../../../other/util.js";

export default class FleetTaskEditor extends React.Component {

    render() {
        let task_text = this.props.tasks.length === 0 ? "No current assignments." : "The fleet is instructed with the following tasks:";
        this.prediction = new FleetStatePredictor(this.props.fleet.location, this.props.fleet.resources.fuel);

        return (
            <div>
                <h2>Fleet Tasks</h2>
                <p className="boring-info-text">{task_text}</p>
                {this.props.tasks.map((task) => this._renderTask(task))}
                <FleetTaskCreateButton onCreateTask={(task) => this._handleAssignTask(task)}
                    fleet={this.props.fleet} />
            </div>)
    }

    _renderTask(task) {
        let fleet = this.props.fleet;
        return (<Task key={task.index}
            task={task}
            tasks={this.props.tasks}
            fleet={fleet}
            prediction={this.prediction}
            mode={this.props.mode}
            resources={this.props.resources}
            onAssignTask={(task) => this._handleAssignTask(task)}
            onDeleteTask={(task) => this._handleDeleteTask(task)}
            onCommitTask={(task) => this.props.onCommitTask(task)}
        />);
    }

    _handleAssignTask(task) {
        if (task.index == null) {
            task.index = this.props.tasks.length;
        }

        let new_tasks = util.clone(this.props.tasks);
        new_tasks[task.index] = task;
        this.props.onUpdateTaskArray(new_tasks);
    }

    _handleDeleteTask(task) {
        if (!this.props.tasks[task.index].pending) {
            return alert("not impl");
        }

        let new_tasks = util.clone(this.props.tasks);
        new_tasks.splice(task.index, 1);
        FleetTaskEditor.helper_cleanUpTaskIndexes(new_tasks);
        this.props.onUpdateTaskArray(new_tasks);
    }

    static helper_cleanUpTaskIndexes(tasks) {
        for (let i = 0; i < tasks.length; i++) {
            if (tasks[i].index !== i && !tasks[i].pending) {
                throw new Error("Index are messed up.");
            }
            tasks[i].index = i;
        }
    }
}
